import { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { ThemeContext } from '../../contexts/ThemeContext';

const starRecMenu = [
    {
        link: "StarRec Dashboard",
        children: [
            {
                link: "Dashboard",
                url: "/StarRec/dashboard"
            },
            {
                link: "Businesses",
                children: [
                    {
                        link: "Approve",
                        url: "/StarRec/businesses/approve"
                    },
                    {
                        link: "Manage",
                        url: "/StarRec/businesses/manage"
                    }
                ]
            },
            {
                link: "Job Holders",
                children: [
                    {
                        link: "Manage",
                        url: "/StarRec/job-holders/manage"
                    },
                ]
            },
            {
                link: "Blacklists",
                children: [
                    {
                        link: "Businesses",
                        url: "/StarRec/blacklists/businesses"
                    },
                    {
                        link: "Job Holders",
                        url: "/StarRec/blacklists/job-holders"
                    },
                    {
                        link: "Requests",
                        url: "/StarRec/blacklists/requests"
                    }
                ]
            },
            {
                link: "Accounting",
                url: "/StarRec/accounting"
            },
            {
                link: "Settings",
                children: [
                    {
                        link: "Business Entities",
                        url: "/StarRec/settings/business-entities"
                    },
                    {
                        link: "Business Categories",
                        url: "/StarRec/settings/business-categories"
                    }
                ]
            }

        ]
    }
];

const stardeasMenu = [
    {
        link: "Stardeas Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/Stardeas/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    }
];

const staglessMenu = [
    {
        link: "Stagless Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/Stagless/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    }
];

const fluxsterMenu = [
    {
        link: "Fluxster Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/Fluxster/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    }
];

const bachlivMenu = [
    {
        link: "BachLiv Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/BachLiv/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    }
];

const nearchatMenu = [
    {
        link: "NearChat Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/NearChat/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    }
];

const defaultMenu = [
    {
        link: "My Dashboard",
        children: [
            {
                link: "Analytics",
                url: "/analytics"
            },
            {
                link: "Project",
                url: "#"
            },
            {
                link: "Events",
                url: "#"
            },
            {
                link: "My Wallet",
                url: "#"
            }
        ]
    },
    {
        link: "eCommerce",
        children: [
            {
                link: "Analytics",
                url: "#"
            },
            {
                link: "Customers",
                url: "#"
            },
            {
                link: "Comments",
                url: "#"
            },
            {
                link: "Transactions",
                url: "#"
            }
        ]
    },
    {
        link: "HRMS",
        children: [
            {
                link: "Analytics",
                url: "#"
            },
            {
                link: "Employee",
                url: "#"
            },
            {
                link: "Attendance",
                url: "#"
            },
            {
                link: "Departments",
                url: "#"
            },
            {
                link: "Trip",
                url: "#"
            },
            {
                link: "Leave",
                url: "#"
            },
            {
                link: "Office Staff",
                url: "#"
            },
            {
                link: "Payslips",
                url: "#"
            },
            {
                link: "Employee Salary",
                url: "#"
            },
            {
                link: "Holidays",
                url: "#"
            }
        ]
    },
    {
        link: "Hospital",
        children: [
            {
                link: "Analytics",
                url: "#"
            },
            {
                link: "Patient Management",
                url: "#"
            },
            {
                link: "Appointments",
                url: "#"
            },
            {
                link: "Doctors & Staff",
                url: "#"
            },
            {
                link: "Pharmacy & Inventory",
                url: "#"
            },
            {
                link: "Laboratory & Diagnostics",
                url: "#"
            },
            {
                link: "Reports & Compliance",
                url: "#"
            },
            {
                link: "Billing & Finance",
                url: "#"
            }
        ]
    },
    {
        link: "Crypto",
        children: [
            {
                link: "Analytics",
                url: "#"
            },
            {
                link: "User Management",
                url: "#"
            },
            {
                link: "Wallets",
                url: "#"
            },
            {
                link: "Transactions",
                url: "#"
            },
            {
                link: "Trading",
                url: "#"
            },
            {
                link: "Reports",
                url: "#"
            },
            {
                link: "Compliance",
                url: "#"
            },
            {
                link: "Settings",
                url: "#"
            }
        ]
    },
    {
        link: "Finance",
        children: [
            {
                link: "Invoicing",
                url: "#"
            },
            {
                link: "Expenses",
                url: "#"
            }
        ]
    },
    {
        link: "Authentication",
        children: [
            {
                link: "Sign In",
                url: "#"
            },
            {
                link: "Sign Up",
                url: "#"
            },
            {
                link: "Forgot Password",
                url: "#"
            },
            {
                link: "Verification Code",
                url: "#"
            },
            {
                link: "Error page",
                url: "#"
            }
        ]
    }
];


export default function Sidebar() {

    const location = useLocation()
    const urlPath = location.pathname

    const { sidebarToggle } = useContext(ThemeContext)

    let menuItem;

    if (urlPath.startsWith('/StarRec')) {
        menuItem = starRecMenu;
    } else if (urlPath.startsWith('/Stardeas')) {
        menuItem = stardeasMenu;
    } else if (urlPath.startsWith('/Stagless')) {
        menuItem = staglessMenu;
    } else if (urlPath.startsWith('/Fluxster')) {
        menuItem = fluxsterMenu;
    } else if (urlPath.startsWith('/BachLiv')) {
        menuItem = bachlivMenu;
    } else if (urlPath.startsWith('/NearChat')) {
        menuItem = nearchatMenu;
    } else {
        menuItem = defaultMenu;
    }

    return (
        <>
            <aside className="left-sidebar border-end z-2">
                <nav className="nav-sidebar">
                    <ul className="list-unstyled mb-0">
                        {menuItem.map((item, key) => {
                            const collapseId = `collapse-${key}`
                            const isOpenByDefault = item.link.includes("Dashboard") || item.link === "Authentication";
                            return (
                                <li key={key}>
                                    <Link className={`d-flex align-items-center justify-content-between hover-svg ${isOpenByDefault ? "" : "collapsed"}`} data-bs-toggle="collapse" to={`#${collapseId}`} role="button" aria-expanded={isOpenByDefault ? "true" : "false"} aria-controls={collapseId}>
                                        <span className="nav-title fs-18 fw-medium">{item.link}</span>
                                        <svg className="opacity-75" width="18" height="18" strokeWidth="0.5" viewBox="0 0 21 21" fill="none" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.5 4.375V16.625" />
                                            <path d="M4.375 10.5H16.625" />
                                        </svg>
                                    </Link>
                                    <div className={`collapse ${isOpenByDefault ? "show" : ""}`} id={collapseId} >
                                        <ul className="nav flex-column">
                                            {item.children.map((res, key2) => {
                                                if (res.children) {
                                                    const subCollapseId = `sub-collapse-${key}-${key2}`;
                                                    const isSubOpenByDefault = res.children.some(child => urlPath.startsWith(child.url));
                                                    return (
                                                        <li className="nav-item" key={key2}>
                                                            <Link className={`nav-link d-flex justify-content-between ${isSubOpenByDefault ? "" : "collapsed"}`} data-bs-toggle="collapse" to={`#${subCollapseId}`} role="button" aria-expanded={isSubOpenByDefault ? "true" : "false"} aria-controls={subCollapseId}>
                                                                <span>{res.link}</span>
                                                                <svg className="opacity-75" width="14" height="14" strokeWidth="0.5" viewBox="0 0 21 21" fill="none" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 7.875L10.5 13.125L15.75 7.875" stroke="currentColor" strokeWidth="1.5"></path></svg>
                                                            </Link>
                                                            <div className={`collapse ${isSubOpenByDefault ? "show" : ""}`} id={subCollapseId}>
                                                                <ul className="nav flex-column ms-3">
                                                                    {res.children.map((child, key3) => (
                                                                        <li className="nav-item" key={key3}>
                                                                            <Link className={`nav-link ${urlPath === child.url ? 'active' : ''}`} to={child.url}>
                                                                                {child.link}
                                                                            </Link>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                return (
                                                    <li className="nav-item" key={key2}>
                                                        <Link className={`nav-link ${urlPath === res.url ? 'active' : ''}`} to={res.url}>
                                                            {res.link}
                                                        </Link>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
            </aside>
            <div className="sidebar-overlay" onClick={() => sidebarToggle()}></div>
        </>
    )
}